import { render } from "./Outlets.vue?vue&type=template&id=2da810f9&scoped=true"
import script from "./Outlets.vue?vue&type=script&lang=js"
export * from "./Outlets.vue?vue&type=script&lang=js"

import "./Outlets.vue?vue&type=style&index=0&id=2da810f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da810f9"]])

export default __exports__